<div class="date-hour-wrapper">
  <mat-form-field appearance="outline">
    @if (label) {
      <mat-label>{{ label }}</mat-label>
    }
    <input
      qtKeyboard
      class="date-picker__input"
      matInput
      (focus)="openOnFocus && picker.open()"
      [required]="requiredDate"
      [matDatepicker]="picker"
      [placeholder]="placeholder ? (placeholder | translate) : ''"
      [formControl]="ts"
      (blur)="onTouched()" />
    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
    <mat-datepicker #picker></mat-datepicker>
    <mat-error [control]="ts" key="matDatepickerParse"></mat-error>
  </mat-form-field>

  @if (time) {
    <qt-time-picker
      class="date-picker__time-field"
      [required]="requiredTime"
      placeholder="{{ 'GNR_START_TIME' | translate }}"
      [formControl]="fullTime"
      [hint]="timezone"></qt-time-picker>
  }
</div>
